import { Link } from "react-router-dom";
import { Shirt } from "lucide-react";
import { useCountdown, pad, LAUNCH_LABEL, useLocalLaunch } from "@/lib/launch";
import { ConfettiBurst } from "./ConfettiBurst";
import { RemindForm } from "./RemindForm";

const Unit = ({ v, l, testid }) => (
  <div className="flex flex-col items-center">
    <span data-testid={testid} className="font-display text-4xl sm:text-6xl leading-none tabular-nums">{pad(v)}</span>
    <span className="mt-1 text-[11px] font-bold uppercase tracking-[0.2em] text-white/70">{l}</span>
  </div>
);

export const LaunchCountdown = () => {
  const { done, d, h, m, s } = useCountdown();
  const local = useLocalLaunch();
  return (
    <section data-testid="launch-countdown" className="px-4 sm:px-8 pt-4 pb-10">
      <div className="relative max-w-[1400px] mx-auto overflow-hidden rounded-[32px] bg-[#1B1530] text-white px-6 sm:px-12 py-10 sm:py-12">
        {done && <ConfettiBurst repeat testid="launch-confetti" />}
        <div className="relative grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-5">
            <p className="eyebrow text-[#FFB21A]">{done ? "It's here" : `Restock drop · ${LAUNCH_LABEL}`}</p>
            {!done && local && <p data-testid="launch-local-time" className="mt-2 text-sm font-semibold text-zinc-300">{local}.</p>}
            <h2 data-testid="launch-title" className="font-display text-4xl sm:text-5xl leading-[0.95] mt-3">
              {done ? "Now available! Go get your bears." : "Fresh bears are almost here."}
            </h2>
            <p data-testid="launch-tee-note" className="mt-5 inline-flex items-start gap-2 rounded-2xl bg-white/10 px-4 py-3 text-sm sm:text-base font-semibold">
              <Shirt className="h-5 w-5 shrink-0 text-[#FFB21A]" />
              The first 5 orders get an unreleased, exclusive Swole Bears T-shirt.
            </p>
          </div>
          <div className="lg:col-span-7 flex flex-col items-center lg:items-end gap-6">
            {done ? (
              <Link to="/build?size=12" data-testid="launch-shop-cta" className="h-14 px-10 rounded-full bg-[#FF5A5F] text-white font-bold text-lg inline-flex items-center hover:bg-white hover:text-[#1B1530] transition-colors">Shop now</Link>
            ) : (
              <div data-testid="launch-timer" className="flex items-start gap-4 sm:gap-8">
                <Unit v={d} l="days" testid="launch-days" />
                <Unit v={h} l="hours" testid="launch-hours" />
                <Unit v={m} l="mins" testid="launch-mins" />
                <Unit v={s} l="secs" testid="launch-secs" />
              </div>
            )}
            {!done && <div id="remind" className="w-full flex justify-center lg:justify-end scroll-mt-32"><RemindForm dark id="launch-remind" /></div>}
            {!done && <Link to="/build?size=12" data-testid="launch-plan-cta" className="text-sm font-bold underline underline-offset-4 text-white/90 hover:text-[#FFB21A]">Plan your box now</Link>}
          </div>
        </div>
      </div>
    </section>
  );
};
